/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useState} from 'react';
// redux
import {useSelector, useDispatch} from 'react-redux';
// material
import {Switch, TextField, InlineMessage, sendErrorMessage} from '@insticator/insticator-ui';
import SectionCard from '../../../../../../material/expandablesection/sectioncard/sectioncard';
import SectionGroup from '../../../../../../material/expandablesection/sectiongroup/sectiongroup';
import SectionGroupDescription from '../../../../../../material/expandablesection/sectiongroupdescription/sectiongroupdescription';
// styles
import injectSheet from 'react-jss';
import styles from './externalpageid_styles';



/* ========== ~~~~~~~~~~ EXTERNAL PAGE ID CONFIGS - SENTIMENT ~~~~~~~~~~ ========== */
const ExternalPageIDConfigs = injectSheet(styles)((props) => {
  const {
    handleChangeEnablePageId,
    enablePageId,
  } = props;
  // const dispatch = useDispatch();
  // const [isOpened, setIsOpened] = useState(false);
  // const savingGeneral = useSelector(({ commentingState }) => commentingState.configStatus.general.savingGeneral);
  // const restoreStateOnCancel = (section) => dispatch(cancelSectionChanges(section));
  // const saveGeneralSettings = (uuid, data, callBack) => dispatch(updateGeneral(uuid, data, callBack));
  return (
    <SectionCard klass={props.classes.externalpageidconfig}>
      <SectionGroup row>
        <SectionGroupDescription
          title={'Enable External Page ID Functionality'}
          description={'Allows to ensure that your comments surface in a persistent manner on a given article under different URLs (e.g. when the URL of an article changes automatically over time). Learn more about External Page ID.'}
        />
        <Switch
          variant={'primary'}
          on={enablePageId === true}
          handleClick={() => handleChangeEnablePageId(!enablePageId)}
        />
      </SectionGroup>
      <InlineMessage
        key={'meow'}
        display={true}
        name={'pageidmessage'}
        variant={'system'}
        icon={'exclamation-triangle'}
        title={null}
        message={<span>Enabling or disabling External Page ID affects the embed codes for the Article Sentiment.</span>}
        close={false}
        handleClose={null}/>
    </SectionCard>
  );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ExternalPageIDConfigs;

